import About from "@/components/About"
import Archive from "@/components/Archive"
import Closing from "@/components/Closing"
import Edition from "@/components/Edition"
import Faq from "@/components/Faq"
import Footer from "@/components/Footer"
import Fragrance from "@/components/Fragrance"
import Header from "@/components/Header"
import Hero from "@/components/Hero"
import MusicScent from "@/components/MusicScent"
import Order from "@/components/Order"

function Home() {
  return (
    <div className="min-h-screen w-full bg-[#080808] text-[#f4efe6]">
      <Header />
      <main>
        <Hero />
        <About />
        <MusicScent />
        <Edition />
        <Fragrance />
        <Archive />
        <Order />
        <Faq />
        <Closing />
      </main>
      <Footer />
    </div>
  )
}

export default Home
